import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mprd-generic-toaster',
  templateUrl: './generic-toaster.component.html',
})
export class GenericToasterComponent {
  @Input() open = false;
  @Input() id = 'toaster';
  @Input() title = '';
  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
